import { Capacitor } from '@capacitor/core'

export const canShareFile = (file: File): boolean =>
  Capacitor.isNativePlatform() &&
  typeof navigator.canShare === 'function' &&
  navigator.canShare({ files: [file] })
